module.exports = __webpack_public_path__ + "img/fig16.158e1659.jpg";